module.exports = "<div class=\"page\">\n\t<header>\n\n\t\t<h1>Download</h1>\n\t</header>\n\t<section>\n\t\t<p>{{file.name}}</p>\n\t\t<a href=\"{{file.path}}\" class=\"button\" download>Get your file</a>\n\t</section>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/download/download.component.html
// module id = ../../../../../src/app/download/download.component.html
// module chunks = main